import { OnboardingAuditFieldIdentifier } from '@mews-commander/data-access';
import { IconButton, IconName, Stack } from '@optimus-web/core';
import { usePrivilegeUserCanEdit } from '../useUserPrivilegeCanEdit';
import { GuideLink } from './GuideLink';
import { useUpdateOnboardingAudit } from './useUpdateOnboardingAudit';

interface RowActionCellProps {
    fieldIdentifier: OnboardingAuditFieldIdentifier;
}

export const RowActionCell = ({ fieldIdentifier }: RowActionCellProps) => {
    const [renderDialog, toggleDialog] = useUpdateOnboardingAudit(fieldIdentifier);
    const userCanEdit = usePrivilegeUserCanEdit();

    return (
        <Stack spacing="150" itemAlignment="center">
            <GuideLink fieldIdentifier={fieldIdentifier} />
            {userCanEdit ? (
                <>
                    <IconButton
                        icon={IconName.Edit}
                        variant="ghost"
                        size="small"
                        onClick={toggleDialog}
                        type="button"
                    />
                    {renderDialog()}
                </>
            ) : null}
        </Stack>
    );
};
